import React, { useState } from "react";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import {
  Select,
  TextArea,
  MyMessage,
  InputField,
  MyButton,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { useAdminContext } from "../../../context/admin/AdminContext";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { _TYPES_ } from "../utils/types";
import BestTimeToVisit from "../../components/BestTimeToVisit";
import Pricing from "../../components/Pricing";
import TourImagesModal from "./addTourImages";
import GenerateDescription from "../utils/GenerateDescription";
import { DescriptionSection } from "../utils/AddSections";
import {
  FiImage,
  FiSun,
  FiList,
  FiShield,
  FiDollarSign,
  FiPlus,
} from "react-icons/fi";
import { FaSuitcaseRolling } from "react-icons/fa";

const TYPES = [
  "Regional Tourism",
  "National Tourism",
  "Adventure Tourism",
  "Beach Tourism",
  "Cultural Tourism",
  "Ecotourism",
  "Heritage Tourism",
  "Green Tourism",
  "Sustainable tourism",
  "Leisure",
  "Culinary",
  "Religious",
  "Music and Dance",
  "Traditional Craft",
];

const Add = () => {
  const { sysAdmin } = useAdminContext();
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [title, setTitle] = useState(null);
  const [type, setType] = useState<any>("Regional Tourism");
  const [hashtags, setHashtags] = useState("");
  const [description, setDescription] = useState(null);
  const [highlights, setHighlights] = useState<any>(null);
  const [itineraryFocus, setItineraryFocus] = useState(1);
  const [groupSize, setGroupSize] = useState<any>(null);
  const [ageRange, setAgeRange] = useState<any>(null);
  const [flightTransport, setFlightTransport] = useState<any>("yes");
  const [startCity, setStartCity] = useState<any>(null);
  const [endCity, setEndCity] = useState<any>(null);
  const [theme, setTheme] = useState<any>(null);
  const [destination, setDestination] = useState<any>(null);
  const [tripIncludes, setTripIncludes] = useState<any>(null);
  const [tripExcludes, setTripExcludes] = useState<any>(null);
  const [priceFrom, setPriceFrom] = useState<any>(null);
  const [pricePerDay, setPricePerDay] = useState<any>(null);
  const [citiesIncluded, setCitiesIncluded] = useState<any>(null);
  const [duration, setDuration] = useState<any>(null);
  const [showTop, setShowTop] = useState(0);
  const [itineraries, setItineraries] = useState<any[]>([
    { title: null, description: null },
  ]);
  const [safetyInfos, setSafetyInfos] = useState<any[]>([
    { title: null, description: null },
  ]);
  const [pricing, setPricing] = useState<any[]>([]);

  const [showTourImages, setShowTourImages] = useState(false);
  const [tourImages, setTourImages] = useState<any[]>([]);

  const [bestTime, setBestTime] = useState<any[]>([]);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const tourPackageRoutes = "/data/tour/package";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(defaultImage);
    setThumbnailId("...");
    setTitle(null);
    setDuration(null);
    setHighlights(null);
    setItineraryFocus(1);
    setGroupSize(null);
    setAgeRange(null);
    setFlightTransport(null);
    setStartCity(null);
    setEndCity(null);
    setTheme(null);
    setType("Regional Tourism");
    setHashtags("");
    setDestination(null);
    setTripIncludes(null);
    setTripExcludes(null);
    setPriceFrom(null);
    setPricePerDay(null);
    setCitiesIncluded(null);
    setDescription(null);
    setShowTop(0);
    setItineraries([{ title: null, description: null }]);
    setSafetyInfos([{ title: null, description: null }]);
    setBestTime([]);
    setPricing([]);
    setTourImages([]);
  };

  const responses = (error: any, message: any) => {
    setError(error);
    setLoading(false);
    setSuccess(!error);
    setErrorMessage(message);
  };

  const addOneTourPackageHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      created_by: sysAdmin?.admin_id,
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      description: description,
      highlights: highlights,
      itinerary_focus: itineraryFocus,
      group_size: groupSize,
      age_range: ageRange,
      flight_transport: flightTransport,
      start_city: startCity,
      end_city: endCity,
      theme: theme,
      destination: destination,
      trip_includes: tripIncludes,
      trip_excludes: tripExcludes,
      price_from: String(priceFrom),
      price_per_day: String(pricePerDay),
      cities_included: citiesIncluded,
      type: type ? type : "Regional Tourism",
      duration: String(duration),
      hashtag: `${tags}, ${hashtags}`,
      company_id: sysAdmin?.company_id || null,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "...",
      status: 1,
      show_top: showTop,
      itineraries: itineraries
        ? itineraries?.filter((x: any) => x?.title && x?.description)
        : [],
      safety_infos: safetyInfos
        ? safetyInfos?.filter((x: any) => x?.title && x?.description)
        : [],
      best_time_to_visit: bestTime?.length > 0 ? String(bestTime) : null,
      pricing: pricing,
      tour_images: tourImages?.filter((x: any) => x?.thumbnail !== null),
    };

    const { message, status } = await createOneContent({
      data: data,
      content: _TYPES_.TOURPACKAGE,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === 200) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  const addToType = (value: string) =>
    setType((type ? type + "," : "") + value);

  const removeFromType = (value: string) => {
    const arr = type
      ?.split(",")
      .filter((pos: string) => value !== pos && value !== "");
    let stream = "";
    arr.forEach(
      (v: string, i: number) =>
        (stream = i < arr.length - 1 ? stream + v + "," : stream + v)
    );
    setType(stream);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  const onChangeNoticeReset = (setter: (v: any) => void) => (e: any) => {
    setter(e.target.value);
    clearMessages();
  };

  return (
    <AddPageShell
      backRoute={tourPackageRoutes}
      eyebrow="DoSee Data • Tour Packages"
      title="Add Tour Package"
      subtitle={`Build a tour package for ${entry_label || "this destination"}.`}
      icon={<FaSuitcaseRolling className="h-5 w-5" />}
      size="xl"
      modals={
        <>
          {showDescriptionModal ? (
            <GenerateDescription
              setDescription={setDescription}
              setShowDescriptionModal={setShowDescriptionModal}
            />
          ) : null}
          <TourImagesModal
            showModal={showTourImages}
            onClick={() => setShowTourImages(false)}
            setTourImages={setTourImages}
            tourImages={tourImages}
          />
        </>
      }
      loading={loading}
      submitLabel="Add Tour Package"
      onSubmit={addOneTourPackageHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null as any);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="A signature shot of the destination."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.TOUR_PACKAGES)}
        />
      </AddSection>

      <AddSection
        title="Tour Package Type"
        hint="Tag the package with one or more tourism categories."
      >
        <div className="flex flex-wrap gap-2">
          {TYPES.map((val) => {
            const on = type?.toString().split(",").includes(val);
            return (
              <span
                key={val}
                role="button"
                tabIndex={0}
                onClick={() => (on ? removeFromType(val) : addToType(val))}
                onKeyDown={(e) =>
                  (e.key === "Enter" || e.key === " ") &&
                  (on ? removeFromType(val) : addToType(val))
                }
                className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs cursor-pointer capitalize transition-colors ${
                  on
                    ? "border-brand bg-brand/10 text-brand"
                    : "border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50"
                }`}
              >
                {on ? (
                  <MdCheckBox className="text-base" />
                ) : (
                  <MdCheckBoxOutlineBlank className="text-base" />
                )}
                {val}
              </span>
            );
          })}
        </div>
      </AddSection>

      <AddSection
        title="Best Time To Visit"
        hint="Months travellers should target."
        icon={<FiSun className="h-4 w-4" />}
      >
        <BestTimeToVisit bestTime={bestTime} setBestTime={setBestTime} />
      </AddSection>

      <AddSection
        title="Tour Details"
        hint="Core fields that describe the package."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
          <InputField
            props={{
              id: "title",
              title: "Tour Title",
              type: "text",
              required: true,
              value: title || "",
              onChange: onChangeNoticeReset(setTitle),
            }}
          />
          <Select
            props={{
              id: "top",
              title: "Show In Top Tour",
              option: ["no", "yes"],
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setShowTop(0);
                else setShowTop(1);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "groupSize",
              title: "Group Size",
              type: "text",
              required: true,
              value: groupSize || "",
              onChange: onChangeNoticeReset(setGroupSize),
            }}
          />
          <InputField
            props={{
              id: "flightTransport",
              title: "Flight fee included?",
              type: "text",
              required: true,
              value: flightTransport || "",
              onChange: onChangeNoticeReset(setFlightTransport),
            }}
          />
          <InputField
            props={{
              id: "startCity",
              title: "Start City",
              type: "text",
              required: true,
              value: startCity || "",
              onChange: onChangeNoticeReset(setStartCity),
            }}
          />
          <InputField
            props={{
              id: "endCity",
              title: "End City",
              type: "text",
              required: true,
              value: endCity || "",
              onChange: onChangeNoticeReset(setEndCity),
            }}
          />
          <InputField
            props={{
              id: "priceFrom",
              title: "Price From (USD)",
              type: "text",
              value: priceFrom ? parseInt(priceFrom) : "",
              onChange: (e: any) => {
                setPriceFrom(parseInt(e.target.value));
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "pricePerDay",
              title: "Price Per Day (USD)",
              type: "text",
              value: pricePerDay ? parseInt(pricePerDay) : "",
              onChange: (e: any) => {
                setPricePerDay(parseInt(e.target.value));
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "citiesIncluded",
              title: "Cities Included (comma separated)",
              type: "text",
              required: true,
              value: citiesIncluded || "",
              onChange: onChangeNoticeReset(setCitiesIncluded),
            }}
          />
          <InputField
            props={{
              id: "duration",
              title: "Duration (Days)",
              type: "text",
              required: true,
              value: duration ? parseInt(duration) : "",
              onChange: (e: any) => {
                const amount = parseInt(e.target.value);
                setDuration(amount);
                const array = Array.from({ length: amount }).map((_, key) => {
                  return {
                    title: `Day ${key + 1} Itinerary`,
                    description: null,
                  };
                });
                setItineraries(array);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "itineraryFocus",
              title: "Itinerary Focus",
              option: ["visible", "invisible"],
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setItineraryFocus(1);
                else setItineraryFocus(0);
                clearMessages();
              },
            }}
          />
          <TextArea
            props={{
              id: "highlights",
              title: "Highlights (comma separated)",
              type: "text",
              required: true,
              value: highlights || "",
              onChange: onChangeNoticeReset(setHighlights),
            }}
          />
          <TextArea
            props={{
              id: "ageRange",
              title: "Age Range (comma separated)",
              type: "text",
              required: true,
              value: ageRange || "",
              onChange: onChangeNoticeReset(setAgeRange),
            }}
          />
          <TextArea
            props={{
              id: "theme",
              title: "Theme (comma separated)",
              type: "text",
              required: true,
              value: theme || "",
              onChange: onChangeNoticeReset(setTheme),
            }}
          />
          <TextArea
            props={{
              id: "destination",
              title: "Destination (comma separated)",
              type: "text",
              required: true,
              value: destination || "",
              onChange: onChangeNoticeReset(setDestination),
            }}
          />
          <TextArea
            props={{
              id: "tripIncludes",
              title: "Trip Includes (comma separated)",
              type: "text",
              required: true,
              value: tripIncludes || "",
              onChange: onChangeNoticeReset(setTripIncludes),
            }}
          />
          <TextArea
            props={{
              id: "tripExcludes",
              title: "Trip Excludes (comma separated)",
              type: "text",
              required: true,
              value: tripExcludes || "",
              onChange: onChangeNoticeReset(setTripExcludes),
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <AddSection
        title="Itineraries"
        hint="Day-by-day breakdown — auto-generated from duration."
        icon={<FiList className="h-4 w-4" />}
      >
        <div className="space-y-4">
          {itineraries?.map((itinerary, index) => (
            <div
              key={index}
              className="rounded-xl border border-gray-100 bg-gray-50 p-4"
            >
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <InputField
                  props={{
                    id: `itinerary-title-${index}`,
                    title: "Title",
                    type: "text",
                    disabled: true,
                    value: itinerary.title || "",
                    onChange: (e: any) => {
                      setItineraries([
                        ...itineraries.map((item, i) => {
                          if (i === index) item.title = e.target.value;
                          return item;
                        }),
                      ]);
                      clearMessages();
                    },
                  }}
                />
                <TextArea
                  props={{
                    id: `itinerary-description-${index}`,
                    title: "Description",
                    type: "text",
                    value: itinerary.description || "",
                    onChange: (e: any) => {
                      setItineraries([
                        ...itineraries?.map((item, i) => {
                          if (i === index) item.description = e.target.value;
                          return item;
                        }),
                      ]);
                      clearMessages();
                    },
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </AddSection>

      <AddSection
        title="Safety Infos"
        hint="Things travellers should know about safety."
        icon={<FiShield className="h-4 w-4" />}
        actions={
          <MyButton
            type="button"
            className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-br from-brand to-primary px-3 py-2 text-xs font-semibold text-white shadow hover:opacity-95"
            onClick={() =>
              setSafetyInfos((it) => [
                ...it,
                { title: null, description: null },
              ])
            }
          >
            <FiPlus className="h-4 w-4" />
            Add Safety Info
          </MyButton>
        }
      >
        <div className="space-y-4">
          {safetyInfos.map((safe, index) => (
            <div
              key={index}
              className="rounded-xl border border-gray-100 bg-gray-50 p-4"
            >
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <InputField
                  props={{
                    id: `safety-title-${index}`,
                    title: "Title",
                    type: "text",
                    value: safe.title || "",
                    onChange: (e: any) => {
                      setSafetyInfos([
                        ...safetyInfos.map((item, i) => {
                          if (i === index) item.title = e.target.value;
                          return item;
                        }),
                      ]);
                      clearMessages();
                    },
                  }}
                />
                <TextArea
                  props={{
                    id: `safety-description-${index}`,
                    title: "Description",
                    type: "text",
                    value: safe.description || "",
                    onChange: (e: any) => {
                      setSafetyInfos([
                        ...safetyInfos.map((item, i) => {
                          if (i === index) item.description = e.target.value;
                          return item;
                        }),
                      ]);
                      clearMessages();
                    },
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </AddSection>

      <AddSection
        title="More Images"
        hint="Optional gallery for this tour."
        icon={<FiPlus className="h-4 w-4" />}
      >
        <MyButton
          type="button"
          className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-800 shadow-sm hover:bg-gray-50"
          onClick={() => setShowTourImages(true)}
        >
          <FiPlus className="h-4 w-4" />
          Click to add more images
          {tourImages?.length > 0 ? (
            <span className="ml-2 inline-flex items-center justify-center rounded-full bg-brand/10 px-2 text-xs font-bold text-brand">
              {tourImages.length}
            </span>
          ) : null}
        </MyButton>
      </AddSection>

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Add;
